// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"bone"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M8.69593 18.3041L18.3041 8.69593C18.6593 8.88981 19.0668 9 19.5 9C20.8807 9 22 7.88071 22 6.5C22 5.27577 21.12 4.25706 19.9581 4.04188C19.7429 2.87996 18.7242 2 17.5 2C16.1193 2 15 3.11929 15 4.5C15 4.93321 15.1102 5.34069 15.3041 5.69593L5.69593 15.3041C5.34069 15.1102 4.93321 15 4.5 15C3.11929 15 2 16.1193 2 17.5C2 18.7242 2.87996 19.7429 4.04188 19.9581C4.25706 21.12 5.27577 22 6.5 22C7.88071 22 9 20.8807 9 19.5C9 19.0668 8.88981 18.6593 8.69593 18.3041Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.69593 18.3041L18.3041 8.69593C18.6593 8.88981 19.0668 9 19.5 9C20.8807 9 22 7.88071 22 6.5C22 5.27577 21.12 4.25706 19.9581 4.04188C19.7429 2.87996 18.7242 2 17.5 2C16.1193 2 15 3.11929 15 4.5C15 4.93321 15.1102 5.34069 15.3041 5.69593L5.69593 15.3041C5.34069 15.1102 4.93321 15 4.5 15C3.11929 15 2 16.1193 2 17.5C2 18.7242 2.87996 19.7429 4.04188 19.9581C4.25706 21.12 5.27577 22 6.5 22C7.88071 22 9 20.8807 9 19.5C9 19.0668 8.88981 18.6593 8.69593 18.3041Z","strokeWidth":"props.strokeWidth"}}]}]};

const BoneIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bone',
    ref,
    icon: element,
  },
));

BoneIcon.displayName = 'BoneIcon';

export default BoneIcon;
